module.exports = __webpack_public_path__ + "img/Postmodernisme_Litteraturen18.feb4ca50.jpg";